class ProductSlider extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        

        document.querySelectorAll('[data-variant-id-coffre]').forEach((el) => {
            el.addEventListener('click', (event) => {
                console.log('click');

                let id = event.currentTarget.closest('[data-product-id]').getAttribute('data-product-id');
                console.log(`Clicked on variant with ID: ${id}`);
                document.querySelector(`.subscrition-funnel product-card[data-product-id="${id}"] .product--quantity__init`).click();
            });
        });

        window.addEventListener('click', (event) => {
            const productModal = document.querySelector('product-modal');
            if (productModal && !event.target.closest('.product-modal__content') && !event.target.closest('.product-card__actions')) {
                productModal.classList.remove('active');
                document.body.classList.remove('overflow-hidden-mobile');
            }
        });


        this.querySelector('.product-modal__close').addEventListener('click', (event) => {
            document.body.classList.remove('overflow-hidden-mobile');
            const productModal = document.querySelector('product-modal');
            if (productModal) {
                productModal.classList.remove('active');
            }
            document.querySelector('.product-modal__content-body').textContent = '';

            const productCards = document.querySelectorAll('.product-card');
            productCards.forEach((card) => {
                const details = card.querySelector('.product-card__details');
                if (details) {
                    details.classList.remove('active');
                    details.style.maxHeight = null;
                }
                const actions = card.querySelector('.product-card__actions');
                if (actions) {
                    actions.classList.remove('active');
                }
            });
        });

        this.querySelectorAll('.product-card__actions').forEach((el) => {
            el.addEventListener('click', this.toggleDetails.bind(this));
        });

        const desktopSwiperEl = this.querySelector('.swiper');
if (desktopSwiperEl) {
  this.swiper_v2 = new Swiper(desktopSwiperEl, {
    direction: 'horizontal',
    loop: false,
    slidesPerView: "auto",
    noSwiping: true,
    noSwipingClass: 'gv-card-carousel',
    pagination: {
      el: this.querySelector('.swiper-pagination'),
      clickable: true,
    },
    navigation: {
      nextEl: this.querySelector('.swiper-button-next'),
      prevEl: this.querySelector('.swiper-button-prev'),
    },
  });
}

const mobileSwiperEl = this.querySelector('.swiper--mobile');
if (mobileSwiperEl) {
  this.swiper = new Swiper(mobileSwiperEl, {
    direction: 'horizontal',
    loop: false,
    slidesPerView: "auto",
    noSwiping: true,
    noSwipingClass: 'gv-card-carousel',
    pagination: {
      el: this.querySelector('.swiper--mobile .swiper-pagination'),
      clickable: true,
    },
    navigation: {
      nextEl: this.querySelector('.swiper--mobile .swiper-button-next'),
      prevEl: this.querySelector('.swiper--mobile .swiper-button-prev'),
    },
  });
}

    }


    toggleDetails(e) {
        e.preventDefault();
        e.currentTarget.classList.toggle('active');
        const productCard = e.currentTarget.closest('.product-card');
        const details = productCard.querySelector('.product-card__details');
        const isOpen = details.classList.toggle('active');
        if (isOpen) {
            details.style.maxHeight = details.scrollHeight + 'px';
        } else {
            details.style.maxHeight = null;
        }

        const productModal = document.querySelector('product-modal');

        if (productModal) {
            productModal.classList.toggle('active');
            productModal.classList.contains('active') ? document.body.classList.add('overflow-hidden-mobile') : document.body.classList.remove('overflow-hidden-mobile');
        }

        document.querySelector('.product-modal__content-body').textContent = '';
        document.querySelector('.product-modal__content-body').innerHTML = productCard.querySelector('.product-card__details-content').innerHTML;
    }
}

customElements.define('product-slider', ProductSlider);